// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2b865163","198":"2ae9d9cd","213":"c280dbcf","239":"602a87ab","245":"03b9cdf3","455":"907283c8"}[chunkId] + ".chunk.js";
};